import ApplicationSerializer from 'cpc-license-manager/serializers/application';

export default class KittingSerializer extends ApplicationSerializer {
  attrs = {
    features: {
      embedded: 'always',
    },
  };
}
